var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.539 50.4208C100.539 22.8676 78.2027 0.53125 50.6494 0.53125C23.0961 0.53125 0.759766 22.8676 0.759766 50.4208V50.4232C0.759766 77.9765 23.0961 100.313 50.6494 100.313C78.2027 100.313 100.539 77.9765 100.539 50.4232V50.4208Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4459 50.4163C89.4459 28.986 72.0731 11.6133 50.6428 11.6133C29.2125 11.6133 11.8398 28.986 11.8398 50.4163V50.4182C11.8398 71.8485 29.2125 89.2212 50.6428 89.2212C72.0731 89.2212 89.4459 71.8485 89.4459 50.4182V50.4163Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3102 45.7531L44.6901 33.6731C39.2501 30.7671 33.2102 36.2771 35.0602 42.4591L38.0102 52.3201L35.0701 62.0961C33.2201 68.2741 39.2501 73.7911 44.6901 70.8941L67.3002 58.8671C72.3702 56.1701 72.3802 48.4581 67.3102 45.7531Z",
    fill: "black",
    fillOpacity: 0.15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0102 52.3201L35.0701 62.0961C33.2201 68.2741 39.2501 73.7911 44.6901 70.8941L67.3002 58.8671C72.3702 56.1701 72.3802 48.4581 67.3102 45.7531L44.6901 33.6731C39.2501 30.7671 33.2102 36.2771 35.0602 42.4591L38.0102 52.3201ZM38.0102 52.3201H45.2201",
    stroke: "black",
    strokeWidth: 3.63867,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 11.1798,
    y1: 4.91925,
    x2: 105.96,
    y2: 25.9952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.a90f69746a2f39fa58b642cb810a4d4d.svg";
export { ForwardRef as ReactComponent };